/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import styles from "../css/SetupForm.module.css";

const DEFAULT_EDIT_MEAL = {

  meal_setting: {
    delivery_hour: "00",
    delivery_min: "00",
    meal_opening_hour: "00",
    meal_closing_hour: "00",
    order_placement: "00",
    editing_allowed: "N",
    cancellation_allowed: "N",
    multiple_order: "N"
  }
};

export default function EditMealForm({ onSave, meals, setMeals, mealModalIndex }) {
  const [editMeal, setEditMeal] = useState({ DEFAULT_EDIT_MEAL });

  useEffect(() => {
    setEditMeal({ ...DEFAULT_EDIT_MEAL, ...meals.find(a => a.meal_uuid === mealModalIndex) })
  }, [meals])

  const handleSubmit = (e) => {
    e.preventDefault()
    setMeals(meals.map(a => a.meal_uuid === mealModalIndex ? { ...editMeal, edit: "true" } : a))
    onSave();
  };




  const getOptions = () => {
    let row = []

    for (let i = 0; i <= 23; i++) {
      row.push(<option>{("00" + i).slice(-2)}</option>)

    }
    return row
  }
  return (
    <div className={styles.form} >
      <div className={styles.heading}>
        <h1>Delivery Setup</h1>
      </div>
      <div className={styles.formContainer}>
        <div className={styles.formGroup}>

          Delivery time (approximately)
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Hours
              <select
                // type="number"
                name="delivery_hour"
                value={editMeal?.meal_setting?.delivery_hour}
                onChange={(e) => setEditMeal({ ...editMeal, meal_setting: { ...editMeal.meal_setting, [e.target.name]: e.target.value } })}
                className={styles.select}


              >
                {getOptions()}
              </select>
            </label>

            <label className={styles.selectLabel}>
              Minutes
              <select
                // type="number"
                name="delivery_min"
                value={editMeal?.meal_setting?.delivery_min}

                onChange={(e) => setEditMeal({ ...editMeal, meal_setting: { ...editMeal.meal_setting, [e.target.name]: e.target.value } })}
                className={styles.select}

              >
                <option value="00">00</option>
                <option value="15">15</option>
                <option value="30">30</option>
                <option value="45">45</option>
              </select>
            </label>
          </div>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Meal opening hours before delivery
              <input
                type="number"
                name="meal_opening_hour"
                value={editMeal?.meal_setting?.meal_opening_hour}

                onChange={(e) => setEditMeal({ ...editMeal, meal_setting: { ...editMeal.meal_setting, [e.target.name]: e.target.value } })}
                className={styles.numberInput}
              />
            </label>

            <label className={styles.selectLabel}>
              Meal closing hours before delivery
              <input
                type="number"
                name="meal_closing_hour"
                value={editMeal?.meal_setting?.meal_closing_hour}

                onChange={(e) => setEditMeal({ ...editMeal, meal_setting: { ...editMeal.meal_setting, [e.target.name]: e.target.value } })}
                className={styles.numberInput}
              />
            </label>
          </div>
          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Order Placement hours before delivery
              <input
                type="number"
                name="order_placement"
                value={editMeal?.meal_setting?.order_placement}

                onChange={(e) => setEditMeal({ ...editMeal, meal_setting: { ...editMeal.meal_setting, [e.target.name]: e.target.value } })}
                className={styles.numberInput}
              />
            </label>
          </div>


          <div className={styles.row}>
            <label className={styles.selectLabel}>
            Editing Allowed till order is
              <select
                name="editing_allowed"
                value={editMeal?.meal_setting?.editing_allowed}
                onChange={(e) => setEditMeal({ ...editMeal, meal_setting: { ...editMeal.meal_setting, [e.target.name]: e.target.value } })}
                className={styles.select}
              >
                <option value="0">Not allowed</option>
                <option value="1">Scheduled</option>
                <option value="2">Placed</option>
                <option value="3">Prepared</option>
              </select>
            </label>

            <label className={styles.selectLabel}>
              Cancellation allowed
              <select
                name="cancellation_allowed"
                value={editMeal?.meal_setting?.cancellation_allowed}
                onChange={(e) => setEditMeal({ ...editMeal, meal_setting: { ...editMeal.meal_setting, [e.target.name]: e.target.value } })}
                className={styles.select}
              >
                <option value="N">Not allowed</option>
                <option value="Y">Allowed</option>
              </select>
            </label>
          </div >

          <div className={styles.row}>
            <label className={styles.selectLabel}>
              Multiple order for one schedule
              <select
                name="multiple_order"
                value={editMeal?.meal_setting?.multiple_order}
                onChange={(e) => setEditMeal({ ...editMeal, meal_setting: { ...editMeal.meal_setting, [e.target.name]: e.target.value } })}
                className={styles.select}
              >
                <option value="N">Not allowed</option>
                <option value="Y">Allowed</option>
              </select>
            </label>
          </div >
        </div >
        <button type="submit" className={styles.submit} onClick={handleSubmit}>
          Save changes
        </button>
      </div >
    </div >
  );
}
